/* eslint-disable @typescript-eslint/no-unused-vars */
import { SternumTheme } from '@sternum/theme';
import { RadioTheme } from '@sternum/ui';

import { Colors } from '../constants';

export function SBOMLightRadioTheme(theme: SternumTheme): Partial<RadioTheme.RadioTheme> {
  return {
    size: '16px',
    borderSize: 0,

    colorNotSelected: Colors.BrandBlueLightest,
    colorSelected: Colors.BrandBlue,
    colorBackground: Colors.BrandBlueLightest,
    colorDisabled: Colors.GreyLightest,
  };
}
